import axios from 'axios';
import { auth } from './firebase';

// Crear una instancia de axios con la configuración base
const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || 'https://gastos.neomeisters.com/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

// Helper to wait for auth state to be ready (Firebase v9 compatible)
const waitForAuthReady = (auth) => {
    return new Promise((resolve) => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            unsubscribe();
            resolve(user);
        });
    });
};

// Interceptor para agregar el token de autorización a cada solicitud
apiClient.interceptors.request.use(
    async (config) => {
        try {
            await waitForAuthReady(auth); // Wait for auth to initialize
            const user = auth.currentUser;
            if (user) {
                // Force refresh token to avoid expiration issues
                const token = await user.getIdToken(true);
                if (process.env.NODE_ENV === 'development') {
                    console.log('🔐 Attaching token to request:', config.url);
                }
                config.headers.Authorization = `Bearer ${token}`;
            } else {
                console.warn('⚠️ No active user found in auth.currentUser when making request to:', config.url);
            }
        } catch (error) {
            console.error('❌ Error getting user token:', error);
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor para manejar respuestas (opcional, útil para debugging o manejo global de errores)
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            console.warn('Acceso no autorizado. Posiblemente el token expiró o es inválido.');
            // Aquí podrías despachar una acción para cerrar sesión si fuera necesario
        }
        return Promise.reject(error);
    }
);

export default apiClient;
